import React, { ReactElement, useEffect, useState } from "react";
import styled from "styled-components";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { slideRightToLeft } from "styles/animations";
import { convertSecondsToMillis } from "utils/time";

const animationDurationInSeconds = 0.5;
const animationDurationInMillis = convertSecondsToMillis(animationDurationInSeconds);

interface Props {
  visible: boolean;
  onClose: () => void;
  children: ReactElement;
}

const Overlay: React.FC<Props> = ({ visible, onClose, children }) => {
  const [shouldRender, setShouldRender] = useState(visible);

  useEffect(() => {
    const timeout = setTimeout(
      () => {
        setShouldRender(visible);

        document.body.style.overflow = visible ? "hidden" : "";
      },
      visible ? 0 : animationDurationInMillis,
    );

    return () => clearTimeout(timeout);
  }, [visible]);

  if (!shouldRender) {
    return null;
  }

  return (
    <Container visible={visible}>
      <CloseButton onClick={onClose}>
        <CloseIcon width="50%" />
      </CloseButton>
      {children}
    </Container>
  );
};

export default Overlay;

const Container = styled.div<{ visible: boolean }>`
  position: fixed;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.grayScale.darkest};
  top: 0;
  left: 0;
  transform: translateX(${({ visible }) => (visible ? 0 : "100%")});
  transition: transform ${animationDurationInSeconds}s;
  animation: ${slideRightToLeft} ${animationDurationInSeconds}s;
`;

const CloseButton = styled.div`
  position: absolute;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  top: 10px;
  right: 10px;
  background-color: ${({ theme }) => theme.colors.grayScale.light};
  opacity: 0.4;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  :hover {
    opacity: 0.7;
  }

  transition: opacity 0.15s;
`;
